import { useState } from 'react';
import { Form, FormItem, Select, Input, Textarea, Avatar } from '../../../components/base';
import { IPluginPromptData } from '../../../libs/models/studio/PluginPromptList';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import PluginPromptCreateDialog from '../PluginPromptCreateDialog';

interface IAionuCreateProfile {
  formData: IPluginPromptData;
  setFormData: React.Dispatch<React.SetStateAction<IPluginPromptData>>;
}

const AionuCreateProfile: React.FC<IAionuCreateProfile> = ({ formData, setFormData }) => {
  const { categoryList } = useAppSelector((state: RootState) => state.category);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption: string | number) => {
    setFormData((prev) => ({ ...prev, pluginCategoryId: selectedOption as string }));
  };

  return (
    <>
      <div className="form-avatar">
        <Avatar
          className={`${dialogOpen}`}
          as="button"
          size="9"
          variant={formData.profileUrl ? 'default' : 'empty'}
          src={formData.profileUrl}
          label={formData.profileUrl ? '에이전트 프로필 이미지' : '이미지는 필수로 등록해주세요'}
          accent="normal"
          badgeProps={{
            icon: 'plus',
            label: '프로필 이미지 등록',
          }}
          // onChange={handleAvatarChange}
          onClick={handleDialogOpen}
        />
      </div>

      <PluginPromptCreateDialog
        isOpen={dialogOpen}
        onClose={handleDialogClose}
        setFormData={setFormData}
        formData={formData}
      />

      <Form variant="vertical" className="form-field" column={2} onSubmit={() => {}}>
        <FormItem label="카테고리" isRequired>
          <Select
            variant="filled"
            size="xlarge"
            placeholder="카테고리명"
            name="pluginCategoryId"
            value={formData.pluginCategoryId as string}
            options={categoryList}
            onChange={handleSelectChange}
            full
          />
        </FormItem>
        <FormItem label="에이전트명" isRequired>
          <Input
            variant="filled"
            size="xlarge"
            placeholder="에이전트 이름을 입력하세요"
            maxLength={16}
            showCount
            name="name"
            value={formData.name as string}
            onChange={handleChange}
            full
          />
        </FormItem>
        <FormItem label="API 인증 Key" className="dsx-w-full">
          <Input
            variant="filled"
            size="xlarge"
            name="apiKey"
            value={formData.aiOnUIConnectData?.apiKey as string}
            onChange={handleChange}
            disabled
            full
          />
        </FormItem>{' '}
        <FormItem label="소개" isRequired className="dsx-w-full">
          <Textarea
            variant="filled"
            size="xlarge"
            placeholder="에이전트 기능에 대한 소개를 적어주세요"
            rows={4}
            maxLength={300}
            showCount
            name="description"
            value={formData.description as string}
            onChange={handleChange}
          />
        </FormItem>{' '}
      </Form>
    </>
  );
};

export default AionuCreateProfile;
